import { FullPageContent } from '@/components/layout/full-page-content';
import { SitesQuery } from '@/project-management/queries/sites.query';

import { SiteCard } from './components/site-card';
import { SitesLoading } from './sites.loading';

export function SitesPage() {
  const listSitesQuery = SitesQuery.useQuery();

  if (listSitesQuery.isLoading) {
    return <SitesLoading />;
  }

  if (listSitesQuery.isError || !listSitesQuery.data) {
    throw listSitesQuery.error;
  }

  const { sites } = listSitesQuery.data;

  return (
    <FullPageContent
      testId="project-management-sites"
      scrollable
      className="space-y-6 bg-zinc-50 p-4"
    >
      <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
        Projects
      </h2>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(16rem,24rem))] gap-4">
        {sites.map((site) => (
          <SiteCard key={site.id} site={site} />
        ))}
      </div>
    </FullPageContent>
  );
}

export default SitesPage;
